import React from 'react';
import claimtip from '../../assets/images/payout_page/Money.svg';
import KYCCollect from '../../components/TapToTip/KYC';

export default function KYC() {
  return (
    <div className="w-full">
      <div className="flex flex-col max-w-[600px] mx-auto p-3">
        <div className="bg-slate-50 rounded-3xl shadow-sm border border-solid border-slate-200 p-6">
          <div className="bg-white rounded-2xl shadow-sm border border-solid border-slate-200 p-3 flex items-center text-[13px] text-slate-600">
            <div className="bg-white rounded-full shadow-sm border border-solid border-slate-200 mr-3 w-[35px] h-[35px] shrink-0 flex items-center justify-center overflow-hidden">
              <img src={claimtip} className="w-full h-full" />
            </div>
            <div>
              <span className="font-bold text-slate-800">Let's get you verified!</span> - Verified
              partners get access to faster uninterrupted payouts.
            </div>
          </div>
        </div>
        <br />
        <KYCCollect />
        <br />
        <button
          type="button"
          className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-colors cursor-pointer border-0"
          onClick={() => {
            window.location = '/tipdirect';
          }}>
          Back to TipDirect
        </button>
      </div>
    </div>
  );
}
